<template>
  <div class="content_qcode">
    <div class="visitorDetail">
      <!-- 访客邀约码 -->
      <span>
        济南高新区丰奥嘉园小学
        <!-- 济南高新区汉峪小学 -->
        <!-- 济南高新区彩虹湖小学 -->
      </span>
      <QRCode class="test"
        url="https://asiait.fengaojiayuanxiaoxue.com/subscribe?appId=wx57217fecd745ff91&schoolId=1070770900580810752"></QRCode>
      <span class="text_span">
        微信扫一扫访客二维码进行访客预约
      </span>
    </div>
  </div>
</template>
<script>
import QRCode from "@/components/subScribePopup/qrcode";
// import assign from '@/mixins/assign'

// 幼高专二维码地址
// url="https://sca.jnpec.edu.cn/mobile/subscribe?appId=wxda773f5504e277d6&schoolId=1321664990142951424"

// 丰奥小学访客地址
// https://asiait.fengaojiayuanxiaoxue.com/subscribe?appId=wx57217fecd745ff91&schoolId=1070770900580810752

// 汉裕小学
// https://www.jngxhyxx.cn/hy/subscribe?appId=wxe7c52ec60a65f675&schoolId=1459386441336975360


// 彩虹湖地址
// https://www.jncaihonghu.cn/chh/subscribe?appId=wxaa780d37627ff89a&schoolId=1606865741919248384



// 测试二维码地址
// url="http://lvyushui.frp.asiait.net/subscribe?appId=wx67673fde185be6d3&schoolId=1321664990142951424"

export default {
  // mixins: [assign],
  components: {
    QRCode,
  },
  created() {
    // this.test()
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.content_qcode {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background-color: red;
}

.visitorDetail {
  width: 80%;
  text-align: center;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  #qrcode {
    background-color: red;
    img {
      width: 0;
    }
  }

  span {
    display: inline-block;
    margin-bottom: 1rem;
  }

  .text_span {
    margin-top: 1rem;
  }
}
</style>
  